import { KidsInfo } from '../../../../member-profile/components/KidsInfo';

const KidsInfoPage = () => {
    return <KidsInfo />;
};

export default KidsInfoPage;
